
export default [

        {
            path:'/video',
            name:'video',
            component:() => import('@/views/video/video'),
            meta: {
    
                keepAlive: true, //此组件需要被缓存
                isBack:false,
            }
    
        },
        
       
        {
            path:'/video_detail',
            name:'video_detail',
            component:() => import('@/views/video/video_detail')

        },
]


// WEBPACK FOOTER //
// ./src/router/video.js